import React, { Component } from 'react';
import authService from './api-authorization/AuthorizeService'

export class Privacy extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      userName: user && user.name
    }));
  }

  render () {
    return (
      <div class="main">
<h4>Политика конфиденциальности</h4>

<p>Planna — ваш персональный планировщик</p>

<p>Последнее обновление: 15.12.2025</p>

<p>Добро пожаловать в Planna! Ваша конфиденциальность крайне важна для нас. Эта Политика объясняет, какую информацию мы собираем, как её используем и защищаем, когда вы пользуетесь нашим сервисом для бронирования, аренды и планирования.</p>

<p>1. Информация, которую мы собираем</p>

<p>1.1. Информация, которую вы нам предоставляете:</p>
<p>
· Учетные данные: Имя, адрес электронной почты, номер телефона, настройки учетной записи.
· Данные профиля: Фотография (если вы добавляете её), предпочтения (например, любимые категории услуг).
· Контент бронирований: Подробности ваших бронирований столиков, отелей, аренды (например, даты, время, выбранные опции, особые пожелания), записи к поставщикам услуг.
· Информация о партнере: Если вы используете функцию «Найти партнера» для бронирования, требующего двух участников, мы обрабатываем ваши предпочтения для поиска совпадения.
· Календарь: С вашего явного согласия мы можем получать доступ к вашему календарю для синхронизации бронирований и создания единого расписания.
· Платежная информация: Данные банковской карты обрабатываются и хранятся на стороне сертифицированного платежного партнера (эквайера). Мы не храним полные реквизиты вашей карты на наших серверах.
</p>
<p>1.2. Информация, собираемая автоматически:</p>
<p>
· Данные об устройстве: Тип устройства, операционная система, уникальные идентификаторы.
· Данные об использовании: История действий в приложении, просмотренные предложения, типы запрашиваемых услуг, частота использования.
· Данные календаря поставщиков: Если вы являетесь поставщиком услуг, с вашего согласия мы синхронизируем данные о вашей рабочей загрузке для отображения клиентам.
</p>
<p>2. Как мы используем вашу информацию</p>

<p>Мы используем собранную информацию для:</p>
<p>
· Предоставления и улучшения сервиса: Обработки бронирований, поиска партнеров, показа вашего единого календаря.
· Персонализации: Рекомендации услуг, предложения с учетом ваших предпочтений и истории.
· Коммуникации: Отправки подтверждений, напоминаний, важных уведомлений (например, о росте загрузки на выбранную дату).
· Безопасности: Предотвращения мошенничества и злоупотреблений.
· Развития сервиса: Анонимного анализа тенденций для улучшения функционала Planna.
</p>
<p>3. Обмен информацией</p>

<p>Мы не продаем ваши персональные данные. Мы можем передавать информацию:</p>
<p>
· Поставщикам услуг: Чтобы выполнить ваше бронирование, мы передаем необходимый минимум данных (ваше имя, контакт, время) ресторану, отелю, мастеру или владельцу арендуемого имущества.
· Партнеру по функции "Найти партнера": В случае успешного подбора мы обмениваемся между участниками только именами и необходимыми для бронирования данными.
· Платежным системам: Для обработки транзакций.
· По закону: Если это требуется по закону или для защиты наших прав.
</p>
<p>4. Ваши права</p>

<p>Вы имеете право:</p>
<p>
· Просматривать, обновлять или удалять данные вашего профиля.
· Отказаться от маркетинговых рассылок.
· Отозвать согласие на синхронизацию календаря в настройках устройства.
· Запросить копию ваших персональных данных.
· Удалить аккаунт, обратившись в службу поддержки.
</p>
<p>5. Безопасность</p>

<p>Мы используем современные методы шифрования (SSL/TLS) для защиты ваших данных при передаче и строгие процедуры для их безопасного хранения.</p>

<p>6. Синхронизация календаря</p>

<p>При включении функции единого календаря:</p>
<p>
· Мы объединяем данные из ваших бронирований в Planna с данными из подключенных внешних календарей (например, Google Calendar, Apple Calendar).
· Эта информация используется исключительно для отображения в вашем личном календаре в Planna и не передается третьим лицам в маркетинговых целях.
· Вы можете в любой момент отключить синхронизацию в настройках приложения.
</p>
<p>7. Функция "Найти партнера"</p>
<p>
· При использовании этой функции мы сопоставляем пользователей только на основе выбранного бронирования и времени.
· Мы никогда не раскрываем ваш полный профиль, контактные данные или историю бронирований потенциальному партнеру без вашего явного согласия в рамках конкретной брони.
· После завершения бронирования связь через сервис может быть ограничена.
</p>
<p>8. Изменения в политике</p>

<p>Мы можем обновлять эту Политику. О существенных изменениях мы уведомим вас через приложение или по электронной почте.</p>

<p>9. Связь с нами</p>

<p>По всем вопросам, касающимся конфиденциальности, обращайтесь:</p>

<p>· Электронная почта: privacy@planna.ru</p>
<p style={{display: "none"}}>· Юридический адрес: [Указать юридический адрес компании]</p>
---
<p>Используя Planna, вы соглашаетесь с условиями этой Политики конфиденциальности.</p>
      </div>
    );
  }
}
